{
	"name": "@memorang/features",
	"version": "1.0.87",
	"license": "MIT",
	"scripts": {
		"typecheck": "tsc --noEmit --pretty"
	},
	"dependencies": {
		"@memorang/constants": "workspace:*",
		"@memorang/helpers": "workspace:*",
		"@memorang/ui": "workspace:*"
	},
	"peerDependencies": {
		"@emotion/react": "^11.10.5",
		"@emotion/styled": "^11.10.5",
		"@gorhom/bottom-sheet": "5.1.8",
		"@mui/material": "^5.10.16",
		"@react-native-community/hooks": "^3.0.0",
		"@tanstack/react-query": "^5.66.7",
		"expo-router": "~6.0.7",
		"houseform": "^1.13.0",
		"markdown-it": "^13.0.1",
		"markdown-it-sub": "^1.0.0",
		"markdown-it-sup": "^1.0.0",
		"react": "19.1.0",
		"react-fast-compare": "^3.2.2",
		"react-native": "0.81.4",
		"react-native-easy-content-loader": "^0.3.2",
		"react-native-markdown-display": "^7.0.0-alpha.2",
		"react-native-math-view": "^3.9.5",
		"react-native-paper": "^5.14.5",
		"react-native-reanimated": "~4.1.1",
		"react-native-safe-area-context": "~5.6.0",
		"react-native-worklets": "~0.6.0",
		"zod": "^3.24.2"
	},
	"devDependencies": {
		"@memorang/typescript": "workspace:*",
		"@types/markdown-it": "^13.0.1",
		"@types/react": "~19.1.10",
		"typescript": "~5.9.2"
	}
}
